module.exports = __webpack_public_path__ + "static/media/img-bg1.56183766.jpg";